<template>
  <div>
    <ParagraphBody>
      Next, navigate to the folder that contains the install and run the installation.
    </ParagraphBody>
    <ParagraphBody>
      Continue through the installer and add the connect key.
    </ParagraphBody>
    <div @click="triggerCopyWellClickedEvent">
      <CopyWell
        :class="$style.copyWell"
        isFullWidth
        label="Connect Key"
        :value="connectKey"
      />
    </div>
  </div>
</template>

<script>
import {
  CopyWell,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const {
  description,
  location,
} = eventProperties;

export default {
  name: 'AgentSetupConnectKey',

  components: {
    CopyWell,
    ParagraphBody,
  },

  EventHelper,

  props: {
    connectKey: {
      type: String,
      required: true,
    },
  },

  methods: {
    triggerCopyWellClickedEvent() {
      this.$options.EventHelper.triggerCopyWellClicked({
        [description]: 'Connect Key copy well clicked',
        [location]: eventLocations.immersiveOnboarding,
      });
    },
  },
};
</script>

<style scoped module>
@import './css/guided-setup.css';
</style>
